/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierUserGetUserIdByEmailRequest
 */
export interface CourierUserGetUserIdByEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierUserGetUserIdByEmailRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the CourierUserGetUserIdByEmailRequest interface.
 */
export function instanceOfCourierUserGetUserIdByEmailRequest(value: object): value is CourierUserGetUserIdByEmailRequest {
    return true;
}

export function CourierUserGetUserIdByEmailRequestFromJSON(json: any): CourierUserGetUserIdByEmailRequest {
    return CourierUserGetUserIdByEmailRequestFromJSONTyped(json, false);
}

export function CourierUserGetUserIdByEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierUserGetUserIdByEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function CourierUserGetUserIdByEmailRequestToJSON(json: any): CourierUserGetUserIdByEmailRequest {
    return CourierUserGetUserIdByEmailRequestToJSONTyped(json, false);
}

export function CourierUserGetUserIdByEmailRequestToJSONTyped(value?: CourierUserGetUserIdByEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

